import { DocumentDTO } from './document.dto';
import { FileDTO } from './file.dto';
import { DistinctId } from './common.dto';

export type GameEntityId = DistinctId<string, 'GameEntityId'>;

export const GAME_ENTITY_IMAGE_WIDTH: Readonly<number> = 200;
export const GAME_ENTITY_IMAGE_HEIGHT: Readonly<number> = 200;

export enum GameEntityType {
  NPC = 'npc',

  Item = 'item',
}

export const GameEntityTypeDetails: Readonly<{
  [type in GameEntityType]: {
    type: GameEntityType;
    icon: string;
    singular: string;
    plural: string;
  };
}> = {
  [GameEntityType.NPC]: {
    type: GameEntityType.NPC,
    icon: '/assets/images/icons/npc-icon.webp',
    singular: 'NPC',
    plural: 'NPCs',
  },
  [GameEntityType.Item]: {
    type: GameEntityType.Item,
    icon: '/assets/images/icons/item-icon.webp',
    singular: 'Item',
    plural: 'Items',
  },
};

export interface GameEntityMinimalDTO {
  id: GameEntityId;

  name: string;

  image: FileDTO | undefined;

  type: GameEntityType;
}

export interface GameEntityFullDTO extends GameEntityMinimalDTO {
  document: DocumentDTO;
}